import { Alert } from 'antd'
import { useSelector } from 'react-redux'

import SectionToYearCard from './SectionToYearCard'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { isNonEmptyArray } from '../../../utils'
import SectionsSelector from '../../../Components/shared/Selectors/SectionsSelector'

const StudentCardPicker = ({ highlighted = { sections: [], sectionToYearsBySection: {} }, student, onCancel, onConfirm }) => {
  const t = useSelector(selectTranslate)

  return (
    <div className='pd-12 m-4'>
      <div className='modal-inner-container'>
        <Alert
          message={t('student_card_picker.labels.student_not_found')}
          type='warning'
          showIcon
        />
        {isNonEmptyArray(student.sections) && (
          <>
            <p> {t('student_card_picker.labels.change_school')}</p>
            <div className='flex-column ai-ctr mt-4 mb-4'>
              {student.sections.map((s, i) => (
                <SectionToYearCard
                  key={`${s.id}_${i}`}
                  section={s}
                  className='zoom m-8 pd-4'
                  onClick={onConfirm}
                />
              ))}
            </div>
          </>
        )}
        <p> {t('student_card_picker.labels.link_student_and_school')}</p>
        <div className='flex-row w-100 mt-4 mb-4'>
          <SectionsSelector
            style={{ width: '50%', marginRight: '8px' }}
            values={null}
            onChange={section => onConfirm({ sectionToYear: { id: null, section: { id: section } } })}
            showSearch
            highlightValues={highlighted.sections}
            multiple='default'
          />
        </div>
      </div>
    </div>
  )
}

export default StudentCardPicker
